import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CloudDocumentService } from '../cloud-document.service';
import { SourceViews } from 'src/app/constants/source-views';

@Component({
    selector: 'app-cloud-document-file-browser',
    templateUrl: './cloud-document-file-browser.component.html',
    styleUrls: ['./../cloud-document.modal.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloudDocumentFileBrowserComponent {
  readonly sourceviewsEnum = SourceViews;

  constructor(private cloudDocumentService: CloudDocumentService) {}

  get isNavigating()     { return this.cloudDocumentService.isNavigating; }
  get canGoBack()        { return this.cloudDocumentService.selectedDirectory.length > 0; }
  get detailsCollapsed() { return this.cloudDocumentService.detailsCollapsed; }
  get selectedViewType() { return this.cloudDocumentService.selectedViewType; }
  get isExportMode()     { return this.cloudDocumentService.isExportMode; }
  get hasSelectedFiles() { return this.cloudDocumentService.selectedFiles.length > 0; }
  /** Single source of truth (service) for whether the Export action should be disabled; keeps this
   *  footer button in sync with the details panel's Export button. */
  get isExportDisabled() { return this.cloudDocumentService.isExportDisabled; }

  pageUp() { this.cloudDocumentService.pageUp(); }
  import() { this.cloudDocumentService.import(); }

  toggleView() {
    const next = this.cloudDocumentService.selectedViewType === SourceViews.Grid ? SourceViews.List : SourceViews.Grid;
    this.cloudDocumentService.selectView(next);
  }

  export() {
    if (this.cloudDocumentService.isForAutoExport) {
      this.cloudDocumentService.prepareExportForAutoExport();
      this.cloudDocumentService.closeDialog();
    } else {
      this.cloudDocumentService.export();
    }
  }
}
